var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"story"}},[_c('div',{staticClass:"col-md-12"},[_c('Scrollama',{attrs:{"debug":true,"offset":0.5},on:{"step-enter":function (ref) {
	var element = ref.element;

	return (_vm.currStep = element.dataset.stepNo);
},"step-exit":function (ref) {
	var element = ref.element;

	return (_vm.currStep = null);
}}},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"step",class:{ active: n == _vm.currStep },attrs:{"data-step-no":n}},[_vm._v(" step "+_vm._s(n)+" ")])}),0),_c('Scrollama',{attrs:{"offset":0.5,"debug":true,"progress":true},on:{"step-enter":function (ref) {
	var element = ref.element;

	return (_vm.currStep = element.dataset.stepNo);
},"step-exit":function (ref) {
	var element = ref.element;

	return (_vm.currStep = null);
},"step-progress":function (ref) {
	var progress = ref.progress;

	return (_vm.currStepProgress = progress);
}}},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"step",class:{ active: n == _vm.currStep },attrs:{"data-step-no":n}},[_c('div',[_vm._v("step "+_vm._s(n))]),_c('div',[_vm._v(_vm._s(Math.round(_vm.currStepProgress * 100))+"%")])])}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }